import SliderImageSeparator from "./SliderImageSeparator"
import ImageTitleItem from "./ImageTitleItem"
import parse from "html-react-parser"
import { useMediaQuery } from "react-responsive"
import PaddingSection from "./PaddingSection"

const TechItem = (props) => {

    const isMobile = useMediaQuery({ maxWidth: 1280 })

    const { title, imageURL, date, textArray } = props

    if (isMobile)
        return (

            <main className="generic-main">

                <ImageTitleItem
                    imageURL="/images/technology/tecnologia-1.jpg"
                    titleText="Conozca las últimas novedades"
                    icon="bi bi-lightbulb blue-icon">
                </ImageTitleItem>
                <SliderImageSeparator />

                <PaddingSection />

                <section className="flex w100 white-bkg">
                    <section className="main-middle-section-mobile">
                        <h2 className="middle-section-title">{title}</h2>
                        <section className="date-label">
                            <i className="bi bi-calendar3 date-icon"></i>
                            <label>{date}</label>
                        </section>
                        <article className="flex acenter jcenter w100">
                            <img loading="lazy" alt="Imagen" src={imageURL} className="blog-image"></img>
                        </article>
                        {
                            textArray.map((text, index) => {
                                return (
                                    <article key={index}>{(typeof text === "string") ? parse(text) : text}</article>
                                )
                            })
                        }
                    </section>
                </section>
            </main>

        )
    else
        return (
            <main className="generic-main">

                <ImageTitleItem
                    imageURL="/images/technology/tecnologia-1.jpg"
                    titleText="Conozca las últimas novedades"
                    icon="bi bi-lightbulb blue-icon">
                </ImageTitleItem>
                <SliderImageSeparator />

                <PaddingSection />

                <section className="flex w100 white-bkg">
                    <section className="main-technology-section">
                        <h2 className="middle-section-title">{title}</h2>
                        <section className="date-label">
                            <i className="bi bi-calendar3 date-icon"></i>
                            <label>{date}</label>
                        </section>
                        <article className="flex acenter jcenter w100">
                            <img loading="lazy" alt="Imagen" src={imageURL} className="blog-image"></img>
                        </article>
                        {
                            textArray.map((text, index) => {
                                return (
                                    <article key={index}>{(typeof text === "string") ? parse(text) : text}</article>
                                )
                            })
                        }
                    </section>
                </section>
            </main>
        )

}

export default TechItem